import * as React from 'react';
import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, MainMenu, Menu, Toolbar } from '@tencent/workbench';
import { IAdjustSlideFeature } from './adjust-slide-interface';
import { MENU_CONFIGS, TOOLBAR_ITEMS, config } from './config';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class AdjustSlideController {
    public constructor(@Loader(IAdjustSlideFeature) private loader: IDynamicLoader<IAdjustSlideFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'dropdownContent')
    public insertDropdown() {
        return <MainMenu
            align="left"
            name={config.id}
            mode="menu"
        />;
    }

    @Menu(ActionType.ADJUST_SLIDE_50, 'onClick')
    @Menu(ActionType.ADJUST_SLIDE_75, 'onClick')
    @Menu(ActionType.ADJUST_SLIDE_100, 'onClick')
    @Menu(ActionType.ADJUST_SLIDE_125, 'onClick')
    @Menu(ActionType.ADJUST_SLIDE_150, 'onClick')
    @Menu(ActionType.ADJUST_SLIDE_200, 'onClick')
    @Menu(ActionType.ADJUST_SLIDE_300, 'onClick')
    @Menu(ActionType.ADJUST_SLIDE_400, 'onClick')
    public onClick(@ActionPointInfo() info: IActionPointInfo) {
        this.feature.handleSlideSizeChange(Number(info.name.split('-')[2]));
    }

    @Menu(ActionType.ADJUST_SLIDE_50, 'shouldCheck')
    @Menu(ActionType.ADJUST_SLIDE_75, 'shouldCheck')
    @Menu(ActionType.ADJUST_SLIDE_100, 'shouldCheck')
    @Menu(ActionType.ADJUST_SLIDE_125, 'shouldCheck')
    @Menu(ActionType.ADJUST_SLIDE_150, 'shouldCheck')
    @Menu(ActionType.ADJUST_SLIDE_200, 'shouldCheck')
    @Menu(ActionType.ADJUST_SLIDE_300, 'shouldCheck')
    @Menu(ActionType.ADJUST_SLIDE_400, 'shouldCheck')
    public shouldCheck(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.shouldCheck(info.name);
    }
}
